module.exports = "/_next/static/images/phone_black-24eb8df03cf5a774427a16f9ce9b99a5.svg";